import SearchProvider from "./SearchProvider";

export default {
  __init__: ['SearchProvider'],
  SearchProvider: ['type', SearchProvider],
}
